import { render, staticRenderFns } from "./ProductGroupShow.vue?vue&type=template&id=afa9b064&scoped=true&"
import script from "./ProductGroupShow.vue?vue&type=script&lang=ts&"
export * from "./ProductGroupShow.vue?vue&type=script&lang=ts&"
import style0 from "./ProductGroupShow.vue?vue&type=style&index=0&id=afa9b064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afa9b064",
  null
  
)

export default component.exports